<div id="labs">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class=" inner-card">
                    <h4 class="card-title ">Biology Lab</h4>
                    <div class="card-body text-justify">
                      <p class="inner-lead"><i>" Biology Is The Science. Evolution Is The Concept That Makes Biology Unique "</i></p>
                      <p class="inner-lead"><i>" Biology is the study of complicated things that have the appearance of having been designed with a purpose "
                      </i></p>
                        <!-- <h5>Biology XI eBooks Link</h5>
                        <hr class="opacity-100">
                        <div class="ranked">
                            <table class="table table-bordered table-hover">
                                <thead>
                                  <tr>
                                    <th scope="col">Particular</th>
                                    <th scope="col">Link</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>eBook</td>
                                    <td><a href="https://ncert.nic.in/textbook.php?kebo1=0-22">https://ncert.nic.in/textbook.php?kebo1=0-22</a></td>
                                  </tr>
                                </tbody>
                              </table>
                        </div> -->
                        <div class="row">
                          <div class="col-6 text-center mb-4">
                            <a href="/assets/img/campus/labs/3.jpeg" data-lightbox="Biology"><img src="/assets/img/campus/labs/3.jpeg" alt="Biology" class="img-fluid rounded"></a>
                            <h5 class="text-center mt-4">Biology</h5>
                          </div>
                          <div class="col-6 text-center mb-4">
                            <a href="/assets/img/campus/labs/2.jpeg" data-lightbox="Physics"><img src="/assets/img/campus/labs/2.jpeg" alt="Physics" class="img-fluid rounded"></a>
                            <h5 class="text-center mt-4">Biology</h5>
                          </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

       
    </div>
</div>